import { jsxs as r, Fragment as a, jsx as o } from "react/jsx-runtime";
import { useTranslation as i } from "../../hooks/useTranslation.js";
import t from "./additionalProducts.module.js";
const m = ({ children: d }) => {
  const { t: s } = i();
  return /* @__PURE__ */ r(a, { children: [
    d && /* @__PURE__ */ r("div", { className: t.additionalProductsContainer, children: [
      /* @__PURE__ */ o("h2", { children: s("recommended_products") }),
      /* @__PURE__ */ o("div", { className: t.additionalProducts, children: d })
    ] }),
    d && /* @__PURE__ */ r("div", { className: t.additionalProductsFooter, children: [
      /* @__PURE__ */ o("h2", { children: s("recommended_products") }),
      /* @__PURE__ */ o("div", { className: t.additionalProducts, children: d })
    ] })
  ] });
};
export {
  m as AdditionalProducts
};
